import axios from 'axios';
import msalInstance from 'src/utility/msal';
import { loginRequestForMsGraph } from 'src/assets/config/authConfig';
import { isValidAccessToken, setMsGraphApiSession, msGraphKey, isValidIdToken } from '../jwt';
import { SilentRequest } from '@azure/msal-browser';
import { handleError } from '../utils';

const axiosConfig = {
  baseURL: 'https://graph.microsoft.com/v1.0/',
  timeout: 30000,
};

const axiosInstance = axios.create(axiosConfig);

axiosInstance.interceptors.request.use(
  async config => {
    let token = localStorage.getItem(msGraphKey);
    if (token && isValidAccessToken(token)) {
      // Do nothing
    } else {
      try {
        const activeAccount = msalInstance.getActiveAccount();
        if (activeAccount && isValidIdToken(activeAccount)) {
          const accessTokenRequest = { scopes: loginRequestForMsGraph.scopes, account: activeAccount } as SilentRequest;
          const response = await msalInstance.acquireTokenSilent(accessTokenRequest);
          token = response.accessToken;
          setMsGraphApiSession(response.accessToken);
        } else {
          msalInstance.loginRedirect(loginRequestForMsGraph);
        }
      } catch (error) {
        handleError(error);
      }
    }

    config.headers = {
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
    return config;
  },
  error => {
    Promise.reject(error)
  });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong for ms graph API.')
);

export default axiosInstance;
